const buergerbueros = [
  {
    name: "Rathaus und Bürgerbüro Gemeinde Poing",
    city: "Poing",
    zip: "85586",
    street: "Rathausstraße 3",
    tel: ["08121 979 4 151", "08121 979 4 152"],
    fax: null,
    email: "post@poing.de",
    url: "https://www.poing.de/rathaus-politik/rathaus/oeffnungszeiten-terminvereinbarung",
    description: "Für Termine, bei denen eine barrierefreie Zugänglichkeit erforderlich ist, vereinbaren Sie bitte vorab einen Termin, damit ein entsprechender Beratungsraum reserviert werden kann. Der Haupteingang zum Rathaus wurde an den Seiteneingang verlegt (Rathausstrasse 3). Die Pforte befindet sich in einem Container vor dem Bauamt (Rathausstraße 4).",
    opening_hours: [
      {
        day: "Montag",
        opening_hours: [
          {
            from: "08:00",
            till: "12:30"
          }
        ]
      },
      {
       day: "Dienstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Mittwoch",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Donnerstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         },
         {
           from: "14:00",
           till: "18:00"
         }
       ]
     },
     {
       day: "Freitag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
    ]
  },
  {
    name: "Bürgerservice der Stadt Rosenheim",
    city: "Rosenheim",
    zip: "83022",
    street: "Königstraße 24",
    tel: ["08031 365 1361"],
    fax: null,
    email: "buergeramt@rosenheim.de",
    url: "https://www.rosenheim.de/buergerservice",
    description: "Im Bürgeramt können verschiedene Arten von amtlichen Bescheinigungen beantragt werden. Amtliche Meldebescheinigungen sind Auszüge aus dem Datenbestand des jeweiligen Melderegisters der Einwohner. Voraussetzung für die Ausstellung ist jedoch, dass die antragstellende Person in Rosenheim gemeldet oder früher gemeldet gewesen ist. Sie dient also nicht der Neuanmeldung einer Wohnung.",
    opening_hours: [
      {
        day: "Montag",
        opening_hours: [
          {
            from: "08:00",
            till: "12:30"
          },
          {
            from: "13:30",
            till: "17:00"
          }
        ]
      },
      {
       day: "Dienstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         },
         {
           from: "13:30",
           till: "17:00"
         }
       ]
     },
     {
       day: "Mittwoch",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         },
         {
           from: "13:30",
           till: "17:00"
         }
       ]
     },
     {
       day: "Donnerstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         },
         {
           from: "13:30",
           till: "17:00"
         }
       ]
     },
     {
       day: "Freitag",
       opening_hours: [
         {
           from: "08:00",
           till: "13:00"
         }
       ]
     },
    ]
  },
  {
    name: "Bürgerbüro Stadtmitte",
    city: "Augsburg",
    zip: "86152",
    street: "An der Blauen Kappe 18",
    tel: ["0821 324 9999"],
    fax: null,
    email: "augsburg@augsburg.de",
    url: "https://www.augsburg.de/buergerservice-rathaus/buergerservice/aemter-behoerden/staedtische-dienststellen/b/buergeramt/buergerbueros/einwohnerwesen/buergerbuero-stadtmitte/",
    description: "Zur Vorsprache in den Bürgerbüros ist eine Terminreservierung notwendig.",
    opening_hours: [
      {
        day: "Montag",
        opening_hours: [
          {
            from: "08:00",
            till: "12:30"
          }
        ]
      },
      {
       day: "Dienstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Mittwoch",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Donnerstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Freitag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
    ]
  },
  {
    name: "Bürgerbüro Kriegshaber",
    city: "Augsburg",
    zip: "86156",
    street: "Ulmer Str. 72",
    tel: ["0821 324 9999"],
    fax: null,
    email: "augsburg@augsburg.de",
    url: "https://www.augsburg.de/buergerservice-rathaus/buergerservice/aemter-behoerden/staedtische-dienststellen/b/buergeramt/buergerbueros/einwohnerwesen/buergerbuero-kriegshaber/",
    description: "Zur Vorsprache in den Bürgerbüros ist eine Terminreservierung notwendig.",
    opening_hours: [
      {
        day: "Montag",
        opening_hours: [
          {
            from: "08:00",
            till: "12:30"
          }
        ]
      },
      {
       day: "Dienstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Mittwoch",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Donnerstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Freitag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
    ]
  },
  {
    name: "Bürgerbüro Haunstetten",
    city: "Augsburg",
    zip: "86179",
    street: "Tattenbachstraße 15",
    tel: ["0821 324 9999"],
    fax: null,
    email: "augsburg@augsburg.de",
    url: "https://www.augsburg.de/buergerservice-rathaus/buergerservice/aemter-behoerden/staedtische-dienststellen/b/buergeramt/buergerbueros/einwohnerwesen/buergerbuero-haunstetten/",
    description: "Zur Vorsprache in den Bürgerbüros ist eine Terminreservierung notwendig.",
    opening_hours: [
      {
        day: "Montag",
        opening_hours: [
          {
            from: "08:00",
            till: "12:30"
          }
        ]
      },
      {
       day: "Dienstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Mittwoch",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Donnerstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Freitag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
    ]
  },
  {
    name: "Bürgerbüro Hochzoll",
    city: "Augsburg",
    zip: "86163",
    street: "Friedberger Str. 115",
    tel: ["0821 324 9999"],
    fax: null,
    email: "augsburg@augsburg.de",
    url: "https://www.augsburg.de/buergerservice-rathaus/buergerservice/aemter-behoerden/staedtische-dienststellen/b/buergeramt/buergerbueros/einwohnerwesen/buergerbuero-hochzoll/",
    description: "Zur Vorsprache in den Bürgerbüros ist eine Terminreservierung notwendig.",
    opening_hours: [
      {
        day: "Montag",
        opening_hours: [
          {
            from: "08:00",
            till: "12:30"
          }
        ]
      },
      {
       day: "Dienstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Mittwoch",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Donnerstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Freitag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
    ]
  },
  {
    name: "Bürgerbüro Lechhausen",
    city: "Augsburg",
    zip: "86167",
    street: "Neuburger Str. 20",
    tel: ["0821 324 9999"],
    fax: null,
    email: "augsburg@augsburg.de",
    url: "https://www.augsburg.de/buergerservice-rathaus/buergerservice/aemter-behoerden/staedtische-dienststellen/b/buergeramt/buergerbueros/einwohnerwesen/buergerbuero-lechhausen/",
    description: "Zur Vorsprache in den Bürgerbüros ist eine Terminreservierung notwendig.",
    opening_hours: [
      {
        day: "Montag",
        opening_hours: [
          {
            from: "08:00",
            till: "12:30"
          }
        ]
      },
      {
       day: "Dienstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Mittwoch",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Donnerstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
     {
       day: "Freitag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:30"
         }
       ]
     },
    ]
  },
  {
    name: "Bürgerbüro Würzburg",
    city: "Würzburg",
    zip: "97070",
    street: "Rückermainstraße 2",
    tel: ["0931 37 24 07"],
    fax: null,
    email: "meldewesen@stadt.wuerzburg.de",
    url: "https://www.wuerzburg.de/rathaus/buergerbuero/meldewesen/531126.Meldewesen.html",
    description: "Wichtige Hinweise zur An- und Ummeldung in Würzburg: Wenn Sie eine Wohnung in Würzburg beziehen, müssen Sie sich innerhalb von zwei Wochen anmelden.",
    opening_hours: [
      {
        day: "Montag",
        opening_hours: [
          {
            from: "07:30",
            till: "13:00"
          }
        ]
      },
      {
       day: "Dienstag",
       opening_hours: [
         {
           from: "07:30",
           till: "12:00"
         },
         {
           from: "13:30",
           till: "16:00"
         }
       ]
     },
     {
       day: "Mittwoch",
       opening_hours: [
         {
           from: "07:30",
           till: "13:00"
         }
       ]
     },
     {
       day: "Donnerstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:00"
         },
         {
           from: "13:30",
           till: "18:00"
         }
       ]
     },
     {
       day: "Freitag",
       opening_hours: [
         {
           from: "07:30",
           till: "12:00"
         }
       ]
     },
    ]
  },
  {
    name: "Stadt Tegernsee",
    city: "Tegernsee",
    zip: "83684",
    street: "Rathausplatz 1",
    tel: ["+49 8022 1801 0"],
    fax: null,
    email: null,
    url: "https://www.stadt.tegernsee.de/Rathaus-B%C3%BCrgerservice/Services/Dienstleistungen/Meldebescheinigung-Beantragung.php?object=tx,3680.2.1&ModID=10&FID=3680.311.1&NavID=3680.43.1&kat=3680.153.1&k_sub=1",
    description: "Eine Meldebescheinigung über Ihren Wohnsitz und ggf. weitere Daten wird für eine Vielzahl von täglichen Angelegenheiten benötigt.",
    opening_hours: [
      {
        day: "Montag",
        opening_hours: [
          {
            from: "08:00",
            till: "12:00"
          },
          {
            from: "14:00",
            till: "16:00"
          }
        ]
      },
      {
       day: "Dienstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:00"
         },
         {
           from: "14:00",
           till: "16:00"
         }
       ]
     },
     {
       day: "Mittwoch",
       opening_hours: [
         {
           from: "07:30",
           till: "13:00"
         }
       ]
     },
     {
       day: "Donnerstag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:00"
         },
         {
           from: "14:00",
           till: "16:00"
         }
       ]
     },
     {
       day: "Freitag",
       opening_hours: [
         {
           from: "08:00",
           till: "12:00"
         }
       ]
     },
    ]
  },
  {
    name: "Einwohneramt Erding",
    city: "Erding",
    zip: "85435",
    street: "Landshuter Straße 4, Zimmer E.05",
    tel: ["+49 8122 408-230"],
    fax: null,
    email: "einwohneramt@erding.de",
    url: "https://www.erding.de/rathaus-buerger-service/verwaltungsgliederung-a-z/einwohneramt",
    description: "Aufgaben sind: Meldewesen, Ausweiswesen, Staatsangehörigkeitswesen, Ausländerangelegenheiten, Führungszeugnisse, Wahlen, Meldebescheinigungen, Einbürgerungsanträge. Eine Online terminvereinbarung ist möglich.",
    opening_hours: [ ]
  },
]


export default buergerbueros
